import { EventVertical } from '../../meta/meta.types';
import { EventType } from '../../meta/meta.types';
import { PaymentMethod } from '../../common/common.types';


export class PaymentHistory {
	eventPaymentId: number;
	eventId: number;
	extendedEventId: string;
	eventName: string;
	eventVertical?: EventVertical;
	eventType?: EventType;
	paidOn: string;
	amount: number;
	currencyCode: string;
	paymentMethod: PaymentMethod;
}
